import React from 'react';

import MortgageForm from "../../../../../components/data-capture/MortgageForm";


    function ApplicationForm({section, inExtWindow=true}) {

        const questions = [
            {
                label: "Total Gift Amount",
                name: 'depositGifts',
                answer: {
                    type: "euro",
                },
                target: `requirement.depositGifts`,
            }
        ]
        return (
            <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
        );
    }


export default ApplicationForm;